(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/use-status-bar-color/assets/prescript.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/use-status-bar-color/assets/prescript.js');

'use strict';

svs.components = svs.components || {};
svs.components.tb_ui_react = svs.components.tb_ui_react || {};
svs.components.tb_ui_react.useStatusBarColor = svs.components.tb_ui_react.useStatusBarColor || {};


 })(window);